import React from "react";
import { ClaimBatchStep } from "components/Picklist/New/ClaimBatchStep";
import { useIsLocal } from "hooks/useIsLocalhost";
import { CreateUnassignedItems } from "./CreateUnassignedItems";
import { AutoPagePaperLayout } from "pages/Layouts/AutoPagePaperLayout";
import { PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export function PicklistNewPage() {
  const isLocal = useIsLocal();

  return (
    <AutoPagePaperLayout paperProps={{ sx: { padding: 3 } }}>
      <PageBreadcrumbs links={[{ label: "Fulfillment" }]} />
      <PageTitle>Picklist</PageTitle>
      <PageSubtitle>Fulfill e-commerce units for laptops in batches.</PageSubtitle>
      <ClaimBatchStep />
      {isLocal && <CreateUnassignedItems />}
    </AutoPagePaperLayout>
  );
}
